import React, { useState } from 'react'
import { Option } from '../common/OptionInput';

export const LinkToPage = ({ link, onLinkChange, onTypeChange, type, pagesList }) => {

    const [pageLinkError, setPageLinkError] = useState(null)

    return (
        <>
            <Option
                id="linkPage"
                checked={type}
                onChange={onTypeChange}
                text="Link to a page in the microsite:"
                value="pageLink"
                name="link"
            >
                <select
                    disabled={type == "pageLink" ? false : true}
                    style={pageLinkError ? { borderColor: "red" } : {}}
                    value={type == "pageLink" ? link : ""}
                    onChange={onLinkChange}
                >
                    <option value="">Select Page</option>
                    {pagesList.map((item, index) => {
                        return (
                            <option value={"#" + item.value} key={index}>
                                {item.title}
                            </option>
                        );
                    })}
                </select>
                {pageLinkError && <span>Please link to a page.</span>}
            </Option>

            {type == "pageLink" && (
                <small className="linkToPageNote">
                    Please note that hyperlinks will be fully operational on the
                    preview/live link, but not within the editor.
                </small>
            )}
        </>
    )
}
